import React from 'react'

const Manual_cambiar_orden_categorias = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo cambiar el orden de las categorías y subcategorías?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Reorganiza fácilmente la disposición de tus categorías y subcategorías dentro del e-commerce.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_cambiar_el_orden_de_las_categorias_y_subcategorias__aYvtdavCSTCBgdxytuSRmQ?as=scrollable"
          className="scribe-iframe-general-120"
          width="100%"
          height="4200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cambiar_orden_categorias
